<template lang="pug">
    .flex-tabs(v-bind:class="{'tab-wrapper no-select': true, 'min': $props.min}" v-if="tabs")
        md-button(
            v-for="(tab, i) in tabs"
            v-bind:class="{'label': true, 'active': (value == tab.name), 'error': tab.error}"
            v-bind:id="(tab.name) ? tab.name : ('tab-' + i)"
            v-bind:key="i"
            v-on:click="changeTab(tab.name)"
        ) {{(tab.label) ? tab.label : ''}}
</template>
<script>
    export default {
        name: 'flex-tabs',
        props: {
            tabs: {
                type: Array,
                default: () => {
                    return []
                }
            }, 
            value: {
                type: String,
                default: null
            },
            min: {
                type: Boolean,
                default: false
            },
            preventInput: {
                type: Boolean,
                default: false
            }
        },
        components: {},
        data() {
            return {}
        },
        computed: {},
        watch: {},
        methods: {
            changeTab(tab) {
                if (!this.$props.preventInput) this.$emit('input', tab);
                this.$emit('change', tab);
            }
        },
        created() {},
    }
</script>
<style>
    .flex-tabs {
        width: 100%;
        overflow-x: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        margin: 0 0 10px 0;
    }
    .flex-tabs .label{
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-grow: 1;
        position: relative;
        min-width: 60px;
        height: 48px;
        border-radius: 0;
        font-size: 12px;
        background-color: #FAFAFA;
        margin: 0 5px;
    }
    .flex-tabs .label:first-child {
        margin-left: 0;
    }
    .flex-tabs .label:last-child {
        margin-right: 0;
    }
    .flex-tabs.min .label{
        height: 26px;
    }
    .flex-tabs .label.active{
        color: #2196f3;
        background-color: #E5F3FE;
    }
    .flex-tabs .label.active::after{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #13A3EF;
    }
    .flex-tabs .label.error{color: red;}
    .flex-tabs .label.error::after{background-color: red;}
</style>



// WEBPACK FOOTER //
// FlexTabs.vue?df0df8c6